import React from 'react'
import PropTypes from 'prop-types'
import { Alert } from '@ticketswap/solar'

const EventWarningAlert = ({ event = {}, ...props }) => {
  const { warning } = event
  if (!warning) return null

  const isTicketSwapUrl = url => {
    const anchor = document.createElement('a')
    anchor.href = url
    return anchor.hostname.indexOf('ticketswap') !== -1
  }

  const handleUrl = url => {
    const openInSameTab = isTicketSwapUrl(url)

    if (openInSameTab) {
      return (window.location.href = url)
    }

    // eslint-disable-next-line security/detect-non-literal-fs-filename
    window.open(warning.url.url, '_blank')
  }

  let callToAction = null

  if (warning.url) {
    callToAction = {
      label: warning.url.text,
      onClick: () => handleUrl(warning.url.url),
    }
  }

  return (
    <Alert
      variant="warning"
      title={warning.title}
      action={callToAction}
      {...props}
    >
      {warning.message}
    </Alert>
  )
}

EventWarningAlert.propTypes = {
  event: PropTypes.shape({
    warning: PropTypes.shape({
      title: PropTypes.string.isRequired,
      message: PropTypes.string.isRequired,
      url: PropTypes.shape({
        text: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
      }),
    }),
  }),
}

export default EventWarningAlert
